const teamValues = [
  {
    icon: "ri-award-line",
    title: "Experiencia real",
    description: "Más de 13 años trabajando en el sector energético nos dan el conocimiento práctico que necesitas.",
  },
  {
    icon: "ri-handshake-line",
    title: "Independencia total",
    description: "No somos agentes de ninguna comercializadora. Trabajamos exclusivamente en tu beneficio.",
  },
  {
    icon: "ri-team-line",
    title: "Equipo comprometido",
    description: "Un equipo pequeño, cercano y apasionado que pone la excelencia por encima del volumen.",
  },
];

export default function About() {
  return (
    <section id="sobre-nosotros" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://public.readdy.ai/ai/img_res/76037769877f68f17ed95c8cf1d4400f.jpg"
                alt="Equipo Faro Energía"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-faro-yellow rounded-xl p-5 shadow-lg">
              <div className="text-faro-navy text-3xl font-bold leading-none">13+</div>
              <div className="text-faro-navy/70 text-xs font-medium mt-1">años de experiencia</div>
            </div>
            {/* Decorative accent */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-faro-teal-pale rounded-2xl -z-10" />
          </div>

          {/* Right: Content */}
          <div>
            <span className="text-faro-teal text-sm font-semibold uppercase tracking-widest">
              Sobre nosotros
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-faro-navy mt-3 mb-6 leading-tight">
              Somos tu faro en el<br />mercado energético
            </h2>
            <p className="text-faro-gray-text text-base leading-relaxed mb-4">
              Faro Energía nació con una misión clara: devolver el control a los consumidores en un mercado energético cada vez más complejo y opaco. Como un faro que guía a los barcos en la oscuridad, orientamos a nuestros clientes con honestidad, claridad y más de 13 años de conocimiento real del sector.
            </p>
            <p className="text-faro-gray-text text-base leading-relaxed mb-8">
              Trabajamos principalmente con clientes de Barcelona y Castellón de la Plana — particulares, pymes, comunidades de propietarios y negocios. Nuestro enfoque es siempre el mismo: escuchar, analizar en profundidad y proponer soluciones reales y medibles.
            </p>

            {/* Values */}
            <div className="flex flex-col gap-5">
              {teamValues.map((val) => (
                <div key={val.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-faro-teal-pale text-faro-teal rounded-lg flex-shrink-0">
                    <i className={`${val.icon} text-lg`} />
                  </div>
                  <div>
                    <h4 className="text-faro-navy font-semibold text-sm mb-1">{val.title}</h4>
                    <p className="text-faro-gray-text text-sm leading-relaxed">{val.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
